import { mapValues, pick } from 'lodash'
import { normalize } from 'helpers/normalizeHelpers'
import { MetaData, Category, RawMetaData } from 'interfaces/meta'
import { ALL_CATEGORY_ID, ALL_ACCOUNT_CATEGORY_TITLE } from 'constants/meta'
import { Transaction, RawTransaction, TransactionStatus } from 'interfaces/moneyflow'
import { Collection } from 'interfaces'
import { saturateCategory } from 'helpers/categoriesHelpers'

type NormalizableMetaField = keyof MetaData

const NORMALIZABLE_META_FIELDS: NormalizableMetaField[] = [
  'peer_ages',
  'peer_creditscores',
  'peer_incomes',
  'spending_categories',
  'income_categories',
  'debt_categories',
  'asset_categories',
]

export const ALL_MONEYFLOW_CATEGORY: Category = {
  id: ALL_CATEGORY_ID,
  value: 'All Categories',
}
export const ALL_ACCOUNT_CATEGORY: Category = {
  id: ALL_CATEGORY_ID,
  value: ALL_ACCOUNT_CATEGORY_TITLE,
}

export const normalizeMeta = (rawMeta: RawMetaData): MetaData => {
  let metaArrayDict: Partial<{ [key in keyof MetaData]: { id: any }[] }> = {}

  metaArrayDict.spending_categories = [{ ...ALL_MONEYFLOW_CATEGORY }, ...rawMeta.spending_categories]
  metaArrayDict.income_categories = [{ ...ALL_MONEYFLOW_CATEGORY }, ...rawMeta.income_categories]

  metaArrayDict.debt_categories = [{ ...ALL_ACCOUNT_CATEGORY }, ...rawMeta.debt_categories]
  metaArrayDict.asset_categories = [{ ...ALL_ACCOUNT_CATEGORY }, ...rawMeta.asset_categories]

  metaArrayDict = { ...rawMeta, ...metaArrayDict }
  const normalized: Partial<MetaData> = mapValues(
    pick(metaArrayDict, NORMALIZABLE_META_FIELDS),
    (array: any) => normalize<{ id: any }, 'id'>(array, 'id'),
  )

  const meta = {
    ...metaArrayDict,
    ...normalized,
  } as MetaData

  return meta
}

export const saturateTransaction = (rawTransaction: RawTransaction, meta: MetaData): Transaction | null => {
  const category = saturateCategory(rawTransaction.category, meta)

  if (!category) {
    return null
  }

  // TODO: Remove this when we have a proper api with lowercase statuses
  const { status: oldStatus, ...restTransaction } = rawTransaction
  const status = oldStatus.toLowerCase() as TransactionStatus

  return {
    ...restTransaction,
    category,
    status,
  }
}

export const saturateTransactions = (rawTransactions: RawTransaction[], meta: MetaData): Collection<Transaction, 'uid'> => {
  const transactions = rawTransactions.reduce<Transaction[]>((acc, item) => {
    const transaction = saturateTransaction(item, meta)

    if (transaction) {
      acc.push(transaction)
    }

    return acc
  }, [])

  return normalize(transactions, 'uid')
}
